import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import queryString from "query-string";
import { getErrorMessage } from "utils/sagasErrorHandler";
import { ITEMS_PER_PAGE } from "constants/general";
import {
    getConfigCITests,
    getConfigCITestsError,
    getConfigCITestsSuccess,
    setTestCases,
    testCaseCancel
} from "modules/ConfigCI/services/ConfigCITests/actions";
import {
    configCiTestTaskCancelRequest,
    getConfigCITestsRequest,
    getTestCaseRequest
} from "modules/ConfigCI/services/ConfigCITests/api";

//Workers
export function* handleRefreshPublishRequests() {
    const { search } = window.location;

    yield put(getConfigCITests({ limit: ITEMS_PER_PAGE, ...queryString.parse(search) }));
}

function* handleGetConfigCITests ({ payload }) {
    try {
        const data = yield call(getConfigCITestsRequest, payload);
        yield put(getConfigCITestsSuccess(data));

        const testCase = yield all(data.config_ci_test_tasks.map(({ id }) => call(getTestCaseRequest, id)));
        let testCasesMap = {};

        testCase.forEach((item) => {
            testCasesMap = { ...testCasesMap, ...item };
        });

        yield put(setTestCases(testCasesMap));
    } catch (error) {
        yield put(getConfigCITestsError());
        getErrorMessage(error);
    }
}

function* handleTestCaseCancel ({ payload }) {
    try {
        yield call(configCiTestTaskCancelRequest, payload);
        yield call(toast.success, `The Test Case with id - ${payload.id} has been successfully canceled`);
        yield handleRefreshPublishRequests();
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* configCITestsSagas() {
    yield all([
        yield takeLatest(getConfigCITests, handleGetConfigCITests),
        yield takeEvery(testCaseCancel, handleTestCaseCancel)
    ]);
}
